import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import { name } from '../symbols'

type OoiMasterPageConfig = { isLazyLoadCompatible: boolean }

const ooiMasterPageConfig: MasterPageConfigFn<OoiMasterPageConfig> = ({ api, funcLib }: VsmContext) => {
	const masterPageData = api.components.getCompData<{ layoutSettings?: { headerToPagesGap?: string } }>('masterPage')
	return { isLazyLoadCompatible: funcLib!.isSiteLazyLoadCompatible(masterPageData ?? {}) }
}

export const masterPageConfig: MasterPageConfigEntry<OoiMasterPageConfig> = {
	name,
	configFactory: ooiMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
